import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { WanHealthComponent } from '@app/features/wan/modules/wan-health/wan-health.component';
import { Authority } from '@app/shared/utils/enums';

export const wanRoutes: Routes = [
    {
        path: 'wan',
        children: [
            {
                path: '',
                component: WanHealthComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.LOGIN, Authority.RESTAURANT_VIEW, Authority.UPDATE],
                    reuse: true
                },
                canActivate: [RouteAccessGuard]
            }
        ]
    }
]